import makeModalStore from "stores/utils/storeMakers/makeModalStore";

const useModalStore = makeModalStore();

export { useModalStore };
